import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, Badge, EmptyState } from "@/components/Common";

export default function AuditLog() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/audit-log").then(({ data }) => setItems(data)).finally(() => setLoading(false));
  }, []);
  return (
    <div>
      <PageHeader
        eyebrow="Administration"
        title="Audit Log"
        subtitle="System activity — who did what, when. Visible to executive leadership only."
      />
      {loading ? (
        <div className="p-10 text-center text-sm text-gray-500">Loading…</div>
      ) : items.length === 0 ? (
        <EmptyState title="No audit entries yet" hint="System activity will appear here as users interact with the platform." />
      ) : (
        <div className="bg-white border border-gray-200 rounded-md overflow-hidden">
          <table className="min-w-full text-sm" data-testid="audit-table">
            <thead className="bg-gray-50">
              <tr>
                {["When", "User", "Role", "Action", "Resource", "Resource ID"].map((h) => (
                  <th key={h} className="text-left text-xs font-bold text-gray-600 uppercase tracking-wider px-4 py-3">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {items.map((a) => (
                <tr key={a.id} className="border-t border-gray-100 hover:bg-gray-50">
                  <td className="px-4 py-3 text-xs text-gray-700 whitespace-nowrap">{new Date(a.created_at).toLocaleString()}</td>
                  <td className="px-4 py-3 font-medium text-gray-900">{a.user_name}</td>
                  <td className="px-4 py-3"><Badge tone="slate">{(a.user_role || "").replaceAll("_", " ")}</Badge></td>
                  <td className="px-4 py-3">
                    <Badge tone={a.action === "delete" ? "red" : a.action === "create" ? "emerald" : a.action === "reject" ? "red" : "blue"}>
                      {a.action}
                    </Badge>
                  </td>
                  <td className="px-4 py-3 text-gray-700">{a.resource}</td>
                  <td className="px-4 py-3 text-xs font-mono text-gray-500">{a.resource_id?.slice(0, 8) || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
